import(/* webpackMode: "eager" */ "/app/apps/egged/app/[locale]/error.tsx");
